/**
 *
 * Utilidades del factor de riesgo de la solicitud.
 *
 * El nivel (alto / medio / bajo) no es un campo propio: viaja en `valora` del
 * valor de la genérica FACTORES_RIESGO_BIENESTAR. Aquí se centraliza esa lectura
 * para que ningún componente tenga que saberlo.
 */

import {
    COLORES_RIESGO,
    ORDEN_NIVEL_RIESGO,
    ORDEN_RIESGO_SIN_FACTOR,
} from '../../helper';

export const nivelDeFactor = (factor) => String(factor?.valora || '').trim();

export const nivelDeSolicitud = (solicitud) => nivelDeFactor(solicitud?.factor_riesgo);

export const estiloRiesgo = (nivel) => COLORES_RIESGO[nivel] || null;

export const ordenDeNivel = (nivel) => ORDEN_NIVEL_RIESGO[nivel] || ORDEN_RIESGO_SIN_FACTOR;

export const ordenarOpcionesPorRiesgo = (opciones) => (
    [...(Array.isArray(opciones) ? opciones : [])].sort((a, b) => {
        const diff = ordenDeNivel(nivelDeFactor(a)) - ordenDeNivel(nivelDeFactor(b));
        if (diff !== 0) return diff;
        return String(a?.nombre || '').localeCompare(String(b?.nombre || ''));
    })
);
